import {
  SET_UPLOADS
} from 'app/actions/types';

import {
  getUploads as getUploadsSvc
} from 'app/services/uploads';

export const getUploads = params => async dispatch => {
  let uploads = await getUploadsSvc(params);

  if (uploads) {
    dispatch({
      type: SET_UPLOADS,
      payload: uploads.params
    });
  }

  return uploads;
}

export const setUploadParams = params => async dispatch => {
  dispatch({
    type: SET_UPLOADS,
    payload: params
  });
}
